import Header from "../../Header";
import formStyle from "../../General CSS/Form.module.css";
import React, {useEffect, useState} from "react";
import {AccountSubmissionTemplate, Payee} from "../../Types/Payee";
import {addMyPayeeAccount, getMyPayeeAccount} from "../../API/PayeeManager";
import {useNavigate} from "react-router-dom";

export default function NewAccount() {
    const [payee, setPayee] = useState<Payee | null>(null);
    const [formErrors, setFormErrors] = useState<{ sortCode?: string, accountNumber?: string }>({});

    const [formData, setFormData] = useState<AccountSubmissionTemplate>({
        sortCode: "",
        accountNumber: "",
        defaultAccount: true,
    });

    const navigate = useNavigate();

    useEffect(() => {
        getMyPayeeAccount()
            .then(response => {
                setPayee(response);
            })
    }, []);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));

        if (name === "sortCode") {
            if (!/^\d{6}$/.test(value)) {
                setFormErrors((prev) => ({
                    ...prev,
                    sortCode: "Sort code must be 6 digits"
                }));
            } else {
                setFormErrors((prev) => {
                    const { sortCode, ...rest } = prev;
                    return rest;
                });
            }
        }

        if (name === "accountNumber") {
            if (!/^\d{8}$/.test(value)) {
                setFormErrors((prev) => ({
                    ...prev,
                    accountNumber: "Account number must be 8 digits",
                }));
            } else {
                setFormErrors((prev) => {
                    const { accountNumber, ...rest } = prev;
                    return rest;
                });
            }
        }
    }

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>): void => {
        e.preventDefault();
        if (formErrors.sortCode || formErrors.accountNumber) {
            alert("Please fix the errors in the form");
            return;
        } else if (formData.sortCode === "" || formData.accountNumber === "") {
            alert("Please fill in all fields");
            return;
        }

        addMyPayeeAccount(formData)
            .catch((err: any) => {
                if (err.status === 422) {
                    navigate("/account/my-account/edit");
                    alert("Duplicate entry")
                } else {
                    alert(err.message || "Unknown Error")
                }
            })
            .then(() => navigate("/account/my-account/edit"));
    }

    return (
        <>
            <Header page={"New Account"} returnLink={"/account/my-account/edit"}/>
            <div className={formStyle.wrapper}>
                <form onSubmit={handleSubmit}>
                    <div className={formStyle.dropdown}>
                        <label htmlFor="name" className={formStyle.label}>Name:</label>
                        <input id="name" value={payee?.name} className={formStyle.inputText} disabled={true}/>
                    </div>
                    <div className={formStyle.dropdown}>
                        <label htmlFor="sortCode" className={formStyle.label}>Sort Code:</label>
                        <input id="sortCode" name="sortCode" value={formData.sortCode} onChange={handleChange} className={formStyle.inputText} placeholder="Enter sort code"/>
                        {formErrors.sortCode && <p className={formStyle.error}>{formErrors.sortCode}</p>}
                    </div>
                    <div className={formStyle.dropdown}>
                        <label htmlFor="accountNumber" className={formStyle.label}>Account Number:</label>
                        <input id="accountNumber" name="accountNumber" value={formData.accountNumber} onChange={handleChange} className={formStyle.inputText} placeholder="Enter account number"/>
                        {formErrors.accountNumber && <p className={formStyle.error}>{formErrors.accountNumber}</p>}
                    </div>
                    <div className={formStyle.dropdown}>
                        <label htmlFor="defaultAccount" className={formStyle.label}>Is default account?</label>
                        <select id="defaultAccount" name="defaultAccount" className={formStyle.inputText}
                                value={formData.defaultAccount ? "true" : "false"}
                                onChange={(e) => setFormData((prev) => ({
                                    ...prev,
                                    defaultAccount: e.target.value === "true",
                                }))}>
                            <option value="true">Yes</option>
                            <option value="false">No</option>
                        </select>
                    </div>
                    <div className={formStyle.submit}>
                        <input className={formStyle.submitBtn} type="submit" value="Submit" title="Submit" />
                    </div>
                </form>
            </div>
        </>
    )
}